/**
 * TeamHub desktop app download URLs.
 *
 * The `stagingmeetsangoma` host reads like a staging environment but is what
 * TeamHub production currently serves. It is expected to change, which is why
 * the base URL is isolated here rather than inlined in the header.
 */

const BASE_URL = 'https://stagingmeetsangoma.z13.web.core.windows.net';

export function getDesktopAppDownloadUrls(): Record<'macos' | 'windows', string> {
  return {
    macos: `${BASE_URL}/teamhub/latest/macos/sangoma-teamhub.dmg`,
    windows: `${BASE_URL}/teamhub/latest/windows/sangoma-teamhub.msi`,
  };
}
